
const styles = {
  container: {
    padding: "20px", 
    fontFamily: "Arial, sans-serif",
    transition: "margin-left 0.3s ease"
  },
  organisationHeader: {
    backgroundColor: '#fff', 
    padding: '20px', 
    borderRadius: '12px', 
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginBottom: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  pageTitle: {
    color: "#1B019B", 
    fontSize: "28px", 
    fontWeight: "bold", 
    marginBottom: "20px"
  },
  actionBar: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#f8f9fa",
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
    marginBottom: "20px",
    gap: "15px",
  },
  addButton: {
    backgroundColor: "#1B019B",
    color: "white",
    padding: "10px 15px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    flex: "1 1 200px",
    minWidth: "150px",
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    flex: "2 1 300px",
    minWidth: "250px",
  },
  searchInput: {
    padding: "10px",
    width: "100%",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  employeeCount: {
    fontWeight: "bold",
    color: "#1B019B",
    flex: "1 1 150px",
    textAlign: "right",
    minWidth: "100px",
  },
  table: {
    width: "100%", 
    borderCollapse: "collapse", 
    backgroundColor: "white",
    borderRadius: "10px", 
    overflow: "hidden",
    boxShadow: "0px 4px 8px rgba(0,0,0,0.1)"
  },
  tableHeader: {
    backgroundColor: "#1B019B", 
    color: "white", 
    height: "60px"
  },
  employeeImage: {
    width: "50px", 
    height: "50px", 
    borderRadius: "50%", 
    objectFit: "cover"
  },
  actionButtons: {
    display: "flex", 
    gap: "8px", 
    justifyContent: "center"
  },
  viewButton: {
    backgroundColor: "#17a2b8", 
    color: "white", 
    border: "none",
    borderRadius: "4px", 
    padding: "6px 8px", 
    cursor: "pointer"
  },
  editButton: {
    backgroundColor: "#ffc107", 
    color: "white", 
    border: "none",
    borderRadius: "4px", 
    padding: "6px 8px", 
    cursor: "pointer"
  },
  deleteButton: {
    backgroundColor: "#dc3545", 
    color: "white", 
    border: "none",
    borderRadius: "4px", 
    padding: "6px 8px", 
    cursor: "pointer"
  },
  noData: {
    textAlign: "center", 
    padding: "15px", 
    color: "#777"
  },
  modalOverlay: {
    position: "fixed", 
    top: 0, 
    left: 0, 
    width: "100vw", 
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    zIndex: 1000, 
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center",
    animation: "fadeIn 0.3s ease-in-out"
  },
  modalContent: {
    backgroundColor: "#fff", 
    padding: "30px", 
    borderRadius: "12px",
    width: "650px", 
    maxHeight: "90vh", 
    overflowY: "auto", 
    position: "relative",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)", 
    animation: "slideIn 0.3s ease-in-out"
  },
  viewModalContent: {
    backgroundColor: "#fff", 
    padding: "30px", 
    borderRadius: "12px",
    width: "500px", 
    position: "relative", 
    maxHeight: "90vh", 
    overflowY: "auto"
  },
  closeButton: {
    position: "absolute", 
    top: "10px", 
    right: "10px",
    background: "transparent", 
    border: "none", 
    fontSize: "22px",
    cursor: "pointer", 
    color: "#999"
  },
  modalTitle: {
    textAlign: "center", 
    color: "#1e3c72", 
    marginBottom: "25px", 
    fontSize: "24px"
  },
  formRow: {
    display: "flex",
    flexWrap: "wrap",      
    gap: "20px",           
    marginBottom: "20px",
  },
  formGroup: {
    flex: "1 1 48%",      
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontWeight: "600",
    marginBottom: "8px",
    color: "#333",
    fontSize: "14px",
  },
  input: {
    padding: "10px 12px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
    outline: "none",
    width: "100%",
    transition: "border-color 0.2s ease",
  },
  select: {
    padding: "10px 12px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
    outline: "none",
    width: "100%",
    transition: "border-color 0.2s ease",
    backgroundColor: "#fff",
  },
  submitButton: {
    backgroundColor: "#1e3c72",
    color: "white",
    padding: "12px 25px",
    borderRadius: "6px",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "bold",
    marginTop: "15px",
    transition: "background-color 0.3s ease",
  },
  employeeImageContainer: {
    textAlign: "center", 
    marginBottom: "20px"
  },
  largeEmployeeImage: {
    width: "120px", 
    height: "120px", 
    borderRadius: "50%", 
    objectFit: "cover"
  },
  qrCodeContainer: {
    textAlign: "center", 
    marginTop: "20px"
  },
  qrCode: {
    width: "150px", 
    height: "150px"
  },
  pdfButton: {
    marginTop: "20px", 
    padding: "10px 20px", 
    backgroundColor: "#1e3c72", 
    color: "#fff",
    border: "none", 
    borderRadius: "5px", 
    cursor: "pointer"
  },
  imagePreviewContainer: {
    marginTop: "0.5rem", 
    position: "relative", 
    display: "inline-block"
  },
  imagePreview: {
    width: "100px", 
    height: "100px", 
    objectFit: "cover",
    borderRadius: "8px", 
    border: "1px solid #ccc"
  },
  removeImageButton: {
    position: "absolute", 
    top: "-8px", 
   
    background: "red", 
    color: "white", 
    border: "none",
    borderRadius: "50%", 
    width: "24px", 
    height: "24px", 
    cursor: "pointer"
  },
  noOrganisation: {
    textAlign: 'center', 
    padding: '60px', 
    backgroundColor: '#fff', 
    borderRadius: 12, 
    boxShadow: '0 0 8px rgba(0,0,0,0.1)'
  },
  permissionsButton: { 
    backgroundColor: "#6f42c1", 
    color: "white", 
    border: "none",
    borderRadius: "4px", 
    padding: "6px 8px", 
    cursor: "pointer"
    
  },
  navButton: {
    backgroundColor: '#1B019B',
    color: 'white',
    borderRadius: '8px 0 0 8px',
    border: '1px solid #1B019B',
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    cursor: 'pointer',
  },

};

export default styles;